module.exports = __webpack_public_path__ + "5402c12304c844c207e12648c3ef7079.png";